<!--
  @Description: 快讯-收藏
  @Author: wang.y 
  @Date: 2022-02-23 
-->
<template>
  <div>
    <div class="commonlist">
      <div class="item" v-for="(item, index) in list" :key="item.id">
        <div class="title over-p1" @click="$parent.goDetail(0, item.uid)"><span>快讯</span>{{item.title}}</div>
        <div class="dec">
          <div class="lt">
            <div class="info-item"><i class="iconfont">&#xe632;</i>发文时间：{{item.publish_time | time_standard}}</div>
          </div>
          <div class="collect_share">
            {{item.create_time}}
            <i class="iconfont collec-icon" @click="handleCancel('0', item.id, cancelCollectCb, index)" title="取消收藏">&#xe66f;</i>
          </div>
        </div>
      </div>
    </div>
    <Spin v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div class="more-btn" v-if="more && !loading">
      <div @click="handleMore('0')">加载更多</div>
    </div>
    <default-list v-if="!list.length && !loading">
      <template slot="p">
        <p>您目前没有收藏任何快讯，不如去随便逛逛<br />看看有什么内容值得收藏起来，反复品读</p>
        <router-link :to="{ name: 'NewsList' }">去快讯列表看看</router-link>
      </template>
    </default-list>
  </div>
</template>
<script>
import DefaultList from './DefaultList'
import { collect_list } from 'js/collect_list'
export default {
  mixins: [ collect_list ],
  components: {
    DefaultList
  },
  created() {
    this.userFavorite('0')
  },
  mounted() { },
  data() {
    return {

    }
  },
  computed: {},
  methods: {
    
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common2.0.stylus'
</style>